import { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import firebase from "../../firebase/compat";
import Location from "../../hooks/Location";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import SelectableGrid from "../../components/common/SelectableGrid";

const ImportResults = () => {
  const [importType, setImportType] = useState("google");
  const researchId = Location()[3];

  const handleLoginSuccess = async (credentialResponse) => {
    // The credential contains the authorization code now.
    const authorizationCode = credentialResponse.credential;
    if (!authorizationCode) {
      console.error("No authorization code received");
      return;
    }

    try {
      // Call your backend Firebase Function to exchange the authorization code for tokens.
      const exchangeAuthCode = firebase.functions().httpsCallable("exchangeAuthCode");
      const result = await exchangeAuthCode({ code: authorizationCode });
      const { access_token: accessToken } = result.data;

      if (!accessToken) {
        console.error("No access token returned from backend");
        return;
      }

      // Now that we have a valid access token, call the Drive API.
      const response = await fetch(
        "https://www.googleapis.com/drive/v3/files?q=mimeType='application/vnd.google-apps.form'",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const data = await response.json();
      console.log("Forms from Drive:", data.files);
    } catch (error) {
      console.error("Error exchanging auth code or fetching Drive data", error);
    }
  };

  const handleLoginError = () => {
    console.log("Login Failed");
  };

  return (
    <div className="main">
      <div className="main-container">
        <div className="page-header">
          <h1>Resultaten importeren</h1>
        </div>
        <SelectableGrid
          items={[
            { id: 'google', label: 'Google Forms' },
            { id: 'microsoft', label: 'Microsoft Forms' },
          ]}
          getId={(item) => item.id}
          getLabel={(item) => item.label}
          selectedId={importType}
          onClick={setImportType}
        />
        {importType === "google" && (
          <div className="dashboard-container">
            <h2>Google Forms</h2>
            <GoogleLogin
              onSuccess={handleLoginSuccess}
              onError={handleLoginError}
              useOneTap
              // Use the minimal scopes that you need – in production you may wish to use `drive.metadata.readonly`
              scope="https://www.googleapis.com/auth/drive.readonly"
              flow="auth-code" // Ensures that an authorization code is returned
            />
          </div>
        )}
        {importType === "microsoft" && (
          <div className="table-container dashboard-container">
            <h2>Microsoft Forms</h2>
            <div id="research-results-import-button-container">
              <ConstructionOutlinedIcon />
              <p>Wordt aan gewerkt</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImportResults;
